import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {VeiculosCorridaModel} from "./veiculos-corrida.model";
import {VeiculosCorridaService} from './veiculos-corrida.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";
import {VeiculosService} from "../veiculos/veiculos.service";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-veiculos-corrida-form',
  templateUrl: './veiculos-corrida-form.component.html'
})
export class VeiculosCorridaFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  corrida: VeiculosCorridaModel = new VeiculosCorridaModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  listVeiculos = [];

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private loginService: LoginService,
    private veiculosService: VeiculosService,
    private veiculosCorridaService: VeiculosCorridaService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_corrida: [],
      id_veiculo: ['', [
        Validators.required,
        BasicValidators.notNull
      ]],
      inicio: ['', [
        Validators.required
      ]],
      termino: ['', [
        Validators.required
      ]],
      km_inicio: ['', [
        Validators.required
      ]],
      km_termino: ['', [
        Validators.required
      ]],
      percurso: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(300)
      ]],
      outro_condutor: [],
      nome_outro_condutor: [],
      avarias: [],
      avarias_descricao: [],
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    // verifica se é uma página para adicionar com parametros get na url
    if(this.router.url.split(/\//).pop().split(/\?/)[0] == 'add'){
      this.pageIsAdd = true;
    }

    this.veiculosService.get()
      .subscribe(
        json => {
          this.listVeiculos = json.Payload;

          // verifica se teve algum veiculo passado por get
          this.route.queryParams.subscribe(paramsGet => {
            if (this.pageIsAdd && paramsGet['veiculo']) {
              this.corrida.id_veiculo = paramsGet['veiculo'];
              if (this.pageIsAdd && paramsGet['veiculo']) {
                this.changeVeiculo(paramsGet['veiculo']);
              }
            }
          });
        },
        error => {
          this.func.showErro(error.json());
        });

    let id = this.route.params.subscribe(params => {
      let id = params['id_corrida'];

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarCorridaVeiculo');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarCorridaVeiculo') : this.func.traduzir('front.cadastrarNovaCorridaVeiculo');
      }

      if (!id) {
        return;
      }

      this.veiculosCorridaService.getById(id)
        .subscribe(
          json => {
            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }

            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarCorridaVeiculo')+': '+this.func.formatDate('data', json.Payload[0].data, this.loginService.getUserInfo(true));
            }else{
              this.title = this.func.traduzir('front.visualizarCorridaVeiculo')+': '+this.func.formatDate('data', json.Payload[0].data, this.loginService.getUserInfo(true));
            }
            this.corrida = json.Payload[0]
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    let valInicio = (this.corrida.km_inicio || '0').toString().replace(',', '.');
    let valTermino = (this.corrida.km_termino || '0').toString().replace(',', '.');
    let kmInicio = parseFloat(valInicio) || 0;
    let kmTermino = parseFloat(valTermino) || 0;
    let kmPercorridos = kmTermino - kmInicio;
    let kmFormatted = kmPercorridos.toString().replace('.', ',');

    let self = this;

    swal({
      title: this.func.traduzir('front.voceTemCerteza'),
      text: this.func.traduzir('front.confirmarCadastroCorrida', { km: kmFormatted }),
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: 'btn-danger',
      confirmButtonText: this.func.traduzir('front.confirmar'),
      cancelButtonText: this.func.traduzir('front.cancelar'),
      closeOnConfirm: true
    },
    function() {
      self.enviando = true;
      let result,
        values = self.corrida; // self.form.value;

      if (values.id_corrida) {
        result = self.veiculosCorridaService.editar(values, values.id_corrida);
      } else {
        result = self.veiculosCorridaService.adicionar(values);
      }

      result.subscribe(data => self.router.navigate(['/painel', 'veiculos-corridas']),
        error => {
          self.enviando = false;
          self.func.showErro(error.json());
        });
    });
  }

  changeVeiculo(e){
    // verifica se teve algum veiculo selecionado
    if(e && e != 'null'){
      for(let i in this.listVeiculos){
        if(this.listVeiculos[i].id_veiculo == e ){
          this.corrida.km_inicio = this.listVeiculos[i].km_atual;
        }
      }
    }else{
      this.corrida.km_inicio = '0';
    }
  }

  changeAvarias(e){
    if(!e){
      this.corrida.avarias_descricao = '';
    }
  }

  changeDescricaoAvarias(e){
    this.corrida.avarias = e.length > 0;
  }

  changeOutroCondutor(e){
    if(!e){
      this.corrida.nome_outro_condutor = '';
    }
  }

  changeNomeCondutor(e){
    this.corrida.outro_condutor = e.length > 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/veiculos-corrida/veiculos-corrida-form.component.ts